The details of the `HiringOrganization` that submitted the candidate profile.
